import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import companyPlanningRecordLetterService from '../../../services/companyPlanningRecordLetterService'
import { CompanyPlanningRecordLetter } from '@leadgen/models/client'
import selectors from './selectors'
import { RootState } from '../../types/RootState'

class CompanyPlanningRecordLettersActions {
  loadCompanyPlanningRecordLettersFresh = createAsyncThunk(
    'companyPlanningRecordLetters/loadCompanyPlanningRecordLettersFresh',
    async ({ companyId }: { companyId: string }, { dispatch }) => {
      const response =
        await companyPlanningRecordLetterService.fetchCompanyPlanningRecordLettersFirstPage({
          companyId,
          onCompanyPlanningRecordLetterAdded: companyPlanningRecordLetter => {
            dispatch(this.addCompanyPlanningRecordLetter(companyPlanningRecordLetter))
          },
          onCompanyPlanningRecordLetterUpdated: companyPlanningRecordLetter => {
            dispatch(this.updateCompanyPlanningRecordLetter(companyPlanningRecordLetter))
          },
        })
      return response
    },
  )
  loadCompanyPlanningRecordLettersNext = createAsyncThunk<
    Awaited<
      ReturnType<
        typeof companyPlanningRecordLetterService.fetchCompanyPlanningRecordLettersNextPage
      >
    >,
    { companyId: string },
    { state: RootState }
  >(
    'companyPlanningRecordLetters/loadCompanyPlanningRecordLettersNext',
    async ({ companyId }, { dispatch, getState }) => {
      const latestTimestamp = selectors.getPaginationTimestamp(getState())
      if (!latestTimestamp) {
        throw new Error('Invalid pagination timestamp')
      }
      const response =
        await companyPlanningRecordLetterService.fetchCompanyPlanningRecordLettersNextPage({
          companyId,
          startAfter: latestTimestamp,
          onCompanyPlanningRecordLetterUpdated: companyPlanningRecordLetter => {
            dispatch(this.updateCompanyPlanningRecordLetter(companyPlanningRecordLetter))
          },
        })
      return response
    },
  )
  addCompanyPlanningRecordLetter = createAction(
    'companyPlanningRecordLetters/addCompanyPlanningRecordLetter',
    (companyPlanningRecordLetter: CompanyPlanningRecordLetter) => ({
      payload: companyPlanningRecordLetter,
    }),
  )
  updateCompanyPlanningRecordLetter = createAction(
    'companyPlanningRecordLetters/updateCompanyPlanningRecordLetter',
    (companyPlanningRecordLetter: CompanyPlanningRecordLetter) => ({
      payload: companyPlanningRecordLetter,
    }),
  )
}

export default new CompanyPlanningRecordLettersActions()
